var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{staticClass:"hc-hexagon-path",attrs:{"fill":_vm.fill,"stroke":_vm.stroke,"stroke-width":_vm.strokeWidth,"d":_vm.d}})}
var staticRenderFns = []

export { render, staticRenderFns }